import { onMounted, ref, UnwrapRef } from 'vue'

export const useClientData = <T, K extends T>(
  fn: ()=>Promise<T>,
  initValue: K
) => {
  const t = ref<T>(initValue)
  const run = async () => {
    const data = await fn()
    t.value = data as UnwrapRef<T>
  }
  onMounted(run)
  return { data: t, run }
}
